import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import "dayjs/locale/en";

export default {
  namespaced: true,
  state: () => ({
    locale: "zh"
  }),
  mutations: {
    setLocale(state, locale) {
      if (locale.startsWith("zh")) {
        state.locale = "zh";
        dayjs.locale("zh-cn");
      } else {
        state.locale = "en";
        dayjs.locale("en-us");
      }
    }
  }
};
